const picList = []
picList.push(require('../img/1.png'))
picList.push(require('../img/2.png'))
picList.push(require('../img/3.png'))
picList.push(require('../img/4.png'))
picList.push(require('../img/5.png'))
export default picList
